import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";

export interface IColumnScope extends ng.IScope {
    // interface
    label: string;
    id: string;
    field: string;
    /**the order in which the columns should show up in the grid.  We need this because kb-if will delay the initialization of kb-column, making them out of order */
    order: number;

    // internal
    colClass: string;
    style: any;
    // toggleSort: () => void;
    sortable: boolean;
    sorted: boolean;
    descending: boolean;
    show: () => boolean;
    getClass: () => string;
    getStyle: () => string;
}
    
@NgComponent({
    token: Token.KbColumn,
    dependencies: [
    ]
})
export class KbColumn extends Directive {
    constructor() {
        super();

        this.require = ["^?kbSearchGrid", "^?kbDataGrid"];
        this.replace = true;
        this.template = Dirs.component("kb-column");
        this.restrict = "AE";
        this.scope = {
            label: "@",
            id: "@",
            field: "@",
            sortable: "=?",
            toggleSort: "&",
            order: "=?"
        };
        this.transclude = true;
        this.link = (scope: IColumnScope, element: ng.IAugmentedJQuery, atts: any, gridCtrl) => {
            if (scope.sortable == null) scope.sortable = true;
            gridCtrl = gridCtrl[0] ? gridCtrl[0] : gridCtrl[1];

            gridCtrl.addColumn(scope);

            scope.show = () => {
                return ((typeof (atts.kbIf) == "undefined") || scope.$parent.$eval(atts.kbIf) != false);
            };

            scope.getClass = () => {
                return element.attr("class");
            };

            scope.getStyle = () => {
                return element.attr("style");
            };
        };

    }

}
